<template>
  <div class="settings">
    <Breadcrumbs :items="breadcrumbs"/>

    <div class="profile">
      <rp-associate-nurse
        @submit="addNurse"
        @lookup="lookup"
        :nurse="nurseExists"
        v-model="nurseData"/>

      <div class="item">
        <h3 v-if="!nurseData">Nurse does not exist. <a href="https://raypro.rayner.com/registration" target="_blank" class="link">Register new nurse?</a></h3>
      </div>
      
      <!-- TODO: Use table instead of list? -->
      <h3 v-if="nurses.length" class="rp-top-bar-title">List of associated nurses:</h3>

      <div v-for="nurse in nurses" :key="nurse.value" class="info-item">
        <span>{{nurse.profile.first_name}} {{nurse.profile.last_name}}</span>
        <rp-sprite name="delete_outline" @click.native="activeConfirmDelete(nurse)"/>
      </div>

      <rp-overlay :active="activeConfirm">
        <rp-confirm
          icon="warning"
          userType="nurse"
          messageType='Unassociate '
          :userName="nurseName"
          :cancel="closeModal"
          :confirm="removeNurse"/>
      </rp-overlay>
    </div>
  </div>
</template>

<script>

import {getAssociatedNurses, addNurseToSurgeon, removeNurseFromSurgeon, getNurseByEmail} from 'raypro_ui/src/api/users'

import RpSprite from 'raypro_ui/src/components/ui/Sprite'
import Breadcrumbs from '@/components/Breadcrumbs'
import AssociateNurse from 'raypro_ui/src/components/ui/forms/AssociateNurse'
import Overlay from 'raypro_ui/src/components/ui/Overlay'
import Confirm from 'raypro_ui/src/components/ui/DeleteConfirm'

export default {
  components: {
    Breadcrumbs,
    RpSprite,
    'rp-associate-nurse': AssociateNurse,
    'rp-overlay': Overlay,
    'rp-confirm': Confirm
  },

  data() {
    return {
      nurseExists: false,
      nurse: {profile: {first_name: '', last_name: ''}},
      hospitalOptions: [],
      nurseData: {},
      nurses: [],
      breadcrumbs: [
        {label: 'Associate nurse'}
      ],
      title: 'Associate nurse',
      activeConfirm: false
    }
  },
  mounted() {
    this.getNurses()
  },
  computed: {
    getUserId() {
      return this.$store.getters.authUser.id
    },

    nurseName() {
      return `${this.nurse.profile.first_name} ${this.nurse.profile.last_name}`
    }
  },

  methods: {
    lookup(val) {
      const email = val.filter

      this.nurseExists = false
      getNurseByEmail(email, true).then((res) => {
        const response = res.data
        const blob = response.map((h) => {
          return {
            'last_name': h.profile.last_name,
            'first_name': h.profile.first_name,
            'email': h.email,
            'id': h.id
          }
        })
        const[first] = blob

        this.nurseData = first
        if(this.nurseData) {
          this.nurseExists = true
        }
      })
    },

    addNurse(val) {
      const data = {
        userId: this.getUserId,
        nurseId: val.id,
        data: {data: {access_code: this.nurseData.access_code}}
      }

      addNurseToSurgeon(data).then(() => {
        // TODO: do something
        this.getNurses()
      })
    },

    getNurses() {
      const userId = this.getUserId

      getAssociatedNurses({userId}).then((res) => {
        const response = res.data
        const blob = response.map((nurse) => {
          return nurse
        })

        this.nurses = blob
      })
    },

    activeConfirmDelete(nurse) {
      this.activeConfirm = !this.activeConfirm
      this.nurse = nurse
    },

    closeModal() {
      this.activeConfirm = !this.activeConfirm
    },

    removeNurse() {
      const nurseId = this.nurse.id
      const payload = {
        userId: this.getUserId,
        nurseId
      }

      removeNurseFromSurgeon(payload)
        .then(() => {
          this.closeModal()
          this.getNurses()
        })
    }
  }
}
</script>

<style lang="sass" scoped>
@import 'raypro_ui/src/styles/base/_variables.sass'
@import 'raypro_ui/src/styles/helpers/_mixins.sass'

.settings
  .profile
    position: relative
    .link
      color: $color-primary
    .rp-top-bar-title
      margin-top: 3rem
    .info-item
      width: 100%
      display: flex
      font-size: 14px
      margin-bottom: 10px
      margin-top: 10px
      margin-left: 20px
      padding-bottom: 15px
      color: $color-text-invert

      span:nth-of-type(1)
        width: 80%
        font-weight: $font-regular

      .sprite
        width: 20px
        height: 20px
        fill: $color-error
        cursor: pointer

</style>



// WEBPACK FOOTER //
// src/components/pages/Settings/AssociateNurse.vue